module.exports = __webpack_public_path__ + "img/H6.fbd250f2.jpg";